import React from "react";
import { decode } from "html-entities";

const TestimonialsCard = ({ testimonial }) => {
  const cleanCheck =
    (window.isMobile == false && window.msg?.enable_clean_version_in_desktop) ||
    (window.isMobile == true && window.msg?.enable_clean_version_in_mobile);

  const directCheck = window.msg?.clean_checkout_if_direct_customer && window.directCheck;

  const enableCleanVersion = directCheck | cleanCheck;

  return (
    <div className="testimonials__box">
      <div className="testimonials__upperRow">
        <div className="testimonials__upperRow__inside">
          <div className="testimonials__stars">
            <span>
              <img
                src={`${window.template_root}/checkout-V4/src/public/stars/${
                  enableCleanVersion ? "safe" : "full"
                }/star-${testimonial.checkout_v4_testimonial_stars}.svg`}
              ></img>
            </span>
          </div>
          <div className="testimonials__name">{testimonial.checkout_v4_testimonial_author}</div>
        </div>
        <div className="testimonials__buyerLabel">
          {window.post_template.checkout_v4_testimonials.tr_checkout_v4_testimonials_verifiedLabel}
        </div>
      </div>
      <div>
        <div className="testimonials__title">{testimonial.tr_checkout_v4_testimonial_title}</div>
        <div className="testimonials__text">{decode(testimonial.tr_checkout_v4_testimonial_description)}</div>
      </div>
    </div>
  );
};

export default TestimonialsCard;
